import AppError from '@/shared/errors/appError.js'
import setupRequestManager from './internal/setupRequestManager.js'
import { ERROR_CODES } from '@/shared/constants/errors.js'

class NetworkRepo {
  constructor() {
    const { sendRequest } = setupRequestManager()
    this.sendRequest = (dataType, method, data) =>
      sendRequest(dataType, method, data)
  }

  async getSingleData(dataKey, filters = {}) {
    const res = await this.sendRequest(
      dataKey,
      filters.requestMethod || 'get',
      filters,
    )

    let error = null
    if (res.statusCode !== 200) {
      error = new AppError(
        'An unknown error occurred while getting data ' + dataKey,
      )
      error.setMetadata({ dataKey, filters, res })
      error.setStatusCode(res.statusCode || 500)
      error.message = res.message || 'Server error'
      error.setCode(
        res.statusCode == 503
          ? ERROR_CODES.SERVICE_UNAVAILABLE
          : ERROR_CODES.SERVER_ERROR,
      )
    }
    return {
      data: res.data,
      message:
        res.message ||
        "Une erreur inconnu s'est produite. Contactez nous si cela persiste",
      statusCode: res.statusCode || error?.statusCode,
      error,
    }
  }

  async triggerAction(dataKey, payload, method = 'post') {
    const res = await this.sendRequest(dataKey, method, payload)

    let error = null
    if (res.statusCode !== 200) {
      error = new AppError('Failed to trigger action on ' + dataKey)
      error.setMetadata({ dataKey, payload, res })
      error.setStatusCode(res.statusCode || 500)
      error.message = res.message || 'Server error'
      error.setCode(
        res.statusCode == 503
          ? ERROR_CODES.SERVICE_UNAVAILABLE
          : ERROR_CODES.SERVER_ERROR,
      )
    }

    return {
      data: res.data,
      message:
        res.message ||
        "Une erreur inconnu s'est produite. Contactez nous si cela persiste",
      statusCode: res.statusCode || error?.statusCode,
      error,
    }
  }
}

export default NetworkRepo
